export default __webpack_public_path__ + "static/media/success.0e9349c2.jpg";